<div class="auth-fluid">
    <!--Auth fluid left content -->
    <div class="auth-fluid-form-box">
      <div class="align-items-center d-flex h-100">
        <div class="card-body">
          <!-- Logo -->
          <div class="auth-brand text-center">
            <a href="index.html" class="logo-dark">
              <span
                ><img src="assets/images/logo/logo.svg" alt="" height="40"
              /></span>
            </a>
            <a href="index.html" class="logo-light">
              <span
                ><img src="assets/images/logo/favicon.png" alt="" height="18"
              /></span>
            </a>
          </div>

          <!-- title-->
          <h4 class="mt-5">Sign Up</h4>
          <p class="text-muted mb-4">
              Create an account now! It only takes a minute.
          </p>

          <!-- form -->
          <form action="#">
            <div class="mb-3">
              <label for="fullname" class="form-label">Full Name</label>
              <input
                class="form-control"
                type="text"
                id="fullname"
                placeholder="Enter your name"
                required
              />
            </div>
            <div class="mb-3">
              <label for="emailaddress" class="form-label"
                >Email address</label
              >
              <input
                class="form-control"
                type="email"
                id="emailaddress"
                required
                placeholder="Enter your email"
              />
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Password</label>
              <input
                class="form-control"
                type="password"
                required
                id="password"
                placeholder="Enter your password"
              />
            </div>
            <div class="mb-3">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="checkbox-signup"
                />
                <label class="form-check-label" for="checkbox-signup"
                  >I accept
                  <a href="javascript: void(0);" class="text-muted"
                    >Terms and Conditions</a
                  ></label
                >
              </div>
            </div>
            <div class="mb-0 d-grid text-center">
              <button class="btn btn-primary" type="submit">
                <i class="mdi mdi-account-circle"></i> Sign Up
              </button>
            </div>
          </form>
          <!-- end form-->

          <!-- Footer-->
          <footer class="footer footer-alt">
            <p class="text-muted">
              Already have account?
              <a href="login.html" class="text-muted ms-1"
                ><b>Log In</b></a
              >
            </p>
          </footer>
        </div>
        <!-- end .card-body -->
      </div>
      <!-- end .align-items-center.d-flex.h-100-->
    </div>
    <!-- end auth-fluid-form-box-->

    <!-- Auth fluid right content -->
    <div class="auth-fluid-right text-center">
      <div class="auth-user-testimonial">
        <h2 class="mb-3">Textile business operating aaplication</h2>
        <p class="lead">
          
        </p>
      </div>
      <!-- end auth-user-testimonial-->
    </div>
    <!-- end Auth fluid right content -->
  </div>